"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmsCdConfiguration = void 0;
var Configuration_js_1 = require("../Configuration.js");
require("./AmsCdMappings.js");
exports.AmsCdConfiguration = Configuration_js_1.Configuration.create('amscd', {
    handler: {
        character: ['amscd_special'],
        macro: ['amscd_macros'],
        environment: ['amscd_environment']
    },
    options: {
        amscd: {
            colspace: '5pt',
            rowspace: '5pt',
            harrowsize: '2.75em',
            varrowsize: '1.75em',
            hideHorizontalLabels: false
        }
    }
});
//# sourceMappingURL=AmsCdConfiguration.js.map